import { render } from "./ErrorPage404.vue?vue&type=template&id=4d19a620"
import script from "./ErrorPage404.vue?vue&type=script&lang=js"
export * from "./ErrorPage404.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__